import { render, staticRenderFns } from "./SaveActivityButton.vue?vue&type=template&id=0d3056f9&"
import script from "./SaveActivityButton.vue?vue&type=script&lang=js&"
export * from "./SaveActivityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports